module.exports = __webpack_public_path__ + "img/lftpay178x70.2a55d528.png";